/**
 * 轻量 SSE 读取：基于 fetch + ReadableStream（可带 AbortSignal）。
 * EventSource 不便传自定义取消与错误细节，故用 fetch 流。
 */
export async function readSse(
  url: string,
  options: {
    signal?: AbortSignal;
    onEvent: (data: unknown) => void;
  },
): Promise<void> {
  const res = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "text/event-stream",
    },
    signal: options.signal,
  });

  if (res.status === 401) {
    window.dispatchEvent(new Event("cinema:unauthorized"));
    throw new Error("未授权");
  }
  if (!res.ok) {
    throw new Error(res.statusText || "SSE 连接失败");
  }
  if (!res.body) {
    throw new Error("浏览器不支持流式响应");
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop() || "";
    for (const part of parts) {
      const lines = part.split("\n");
      for (const line of lines) {
        if (!line.startsWith("data:")) continue;
        const raw = line.slice(5).trim();
        if (!raw || raw === "[DONE]") continue;
        try {
          options.onEvent(JSON.parse(raw) as unknown);
        } catch {
          // 忽略非 JSON 心跳
        }
      }
    }
  }
}
